import { Tabs } from 'antd';
import React from 'react';
import GeneralInfo from './GeneralInfo';
import PopupEnable2FaAuthentication from './PopupEnable2FaAuthentication';
import SecurityTab from './SecurityTab';
import PopupChangePassword from './PopupChangePassword';

const items = [
  {
    label: 'General Info',
    key: 'info',
    children: <GeneralInfo />,
  },
  {
    label: 'Security',
    key: 'security',
    children: <SecurityTab />,
  },
];
const ManagerSettings = () => {
  return (
    <div className="manager-setting-container">
      <div className="manager-setting-container__title">Profile Settings</div>
      <Tabs items={items} />
      <PopupEnable2FaAuthentication />
      <PopupChangePassword />
    </div>
  );
};

export default ManagerSettings;
